import { Col, Media, Row } from "reactstrap";
import { H3, H4, Image, P } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Utils";
import { Invoice } from "../../../../../Constants/Constants";

const InvoiceSixHeader = () => {
  return (
    <div>
      <Row>
        <Col sm="6">
          <Media className="d-flex">
            <div className="media-left">
              <Image className="img-fluid for-light" src={dynamicImage(`logo/logo-1.png`)} alt="looginpage" />
              <Image className="img-fluid for-dark" src={dynamicImage(`logo/logo.png`)} alt="looginpage" />
            </div>
            <Media body className="text-right m-l-20 text-start ">
              <H4 className="media-heading">Berlin</H4>
              <P>hello@berlin.in<br /><span>289-335-6503</span></P>
            </Media>
          </Media>
        </Col>
        <Col sm="6">
          <div className="text-md-end text-xs-center">
            <H3>{Invoice} #<span className="counter">1069</span></H3>
            <P>Issued: May<span> 27, 2024</span><br /> Payment Due: June <span>27, 2024</span></P>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default InvoiceSixHeader;
